import { useStore } from '@/hooks/useStore';
import { observer } from 'mobx-react-lite';
import { useState, useEffect } from 'react';
import 'suneditor/dist/css/suneditor.min.css';
import MileageLimitComp from '@/pages/price-enduser/components/other-setting/MileageLimtComp';
import { MileageLimitSetting } from '@/types/system-setting';

export default observer(function RuleKilometerLimit() {
    // state
    const [mileageLimit, setMileageLimt] = useState<MileageLimitSetting | null>(null);

    // store
    const {
        generalStore: { otherSetting, getOtherSetting }
    } = useStore();

    // lifecycle
    useEffect(() => {
        getOtherSetting();
    }, []);

    useEffect(() => {
        if (otherSetting && Object.keys(otherSetting).length > 0) {
            const { mileageLimit } = otherSetting;
            setMileageLimt(mileageLimit);
        }
    }, [otherSetting]);

    return (
        <div className='overflow-y-auto lg:max-h-[85vh] xsm:max-h-[80vh] max-h-[70vh]'>
            {
                mileageLimit && <MileageLimitComp mileageLimitSetting={mileageLimit} isOnPopUp />
            }
        </div>
    );
});
